import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Button,
  ModalBody,
  ModalFooter,
} from "@chakra-ui/react";
import ManufacturingFacilityForm, { FormProps } from "./Form";

type Props = FormProps & {
  isSaving: boolean;
  modeLabel: string;
  onNavigateToList: () => void;
  onCancel: () => void;
};

export default function ManufacturingFacilityFormSection({
  isSaving,
  modeLabel,
  onNavigateToList,
  onCancel,
  ...formProps
}: Props) {
  return (
    <>
      <ModalBody pb={6}>
        <Box mb={4}>
          <Breadcrumb fontSize="sm" separator="›" mb={2}>
            <BreadcrumbItem>
              <BreadcrumbLink
                as="button"
                type="button"
                onClick={onNavigateToList}
              >
                Facilities
              </BreadcrumbLink>
            </BreadcrumbItem>

            <BreadcrumbItem isCurrentPage>
              <BreadcrumbLink>{modeLabel}</BreadcrumbLink>
            </BreadcrumbItem>
          </Breadcrumb>
        </Box>

        <ManufacturingFacilityForm {...formProps} />
      </ModalBody>

      <ModalFooter>
        <Button
          type="button"
          variant="ghost"
          mr={3}
          size="sm"
          onClick={onCancel}
        >
          Cancel
        </Button>

        <Button
          type="submit"
          colorScheme="pinkButton"
          size="sm"
          form={formProps.formId}
          isLoading={isSaving}
        >
          Save
        </Button>
      </ModalFooter>
    </>
  );
}
